<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Gerar MDFE</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Gerar MDFE"><i class="ft-plus"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>

                                    <vuetable ref="vuetable"
                                    api-url="/api/gerarmdfe"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="doc_id"
                                    pagination-path=""
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:cell-clicked="onDetail"
                                    @vuetable:loaded="onLoaded"
                                    detail-row-component="gerar-mdfe-detalhes"
                                    >
                                    <template slot="actions" slot-scope="props">
                                      <div class="custom-actions">
                                          <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus-square"></i></a>
                                      </div>
                                    </template>
                                    <template slot="status_sefaz" slot-scope="props">
                                        <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==1">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-secondary" v-if="props.rowData.doc_cte.status_sefaz.valor==2">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==3">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-success" v-if="props.rowData.doc_cte.status_sefaz.valor==4">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==5">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==6">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==7">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        <span class="badge badge-info" v-if="props.rowData.doc_cte.status_sefaz.valor==8">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                      </template>
                                      <template slot="b_modal" slot-scope="props">
                                          <span class="badge badge-danger" v-if="props.rowData.b_modal.descr=='Multimodal'">{{ props.rowData.b_modal.descr }}</span>
                                          <span class="badge badge-default" v-if="props.rowData.b_modal.descr=='Rodoviário'">{{ props.rowData.b_modal.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.b_modal.descr=='Aéreo'">{{ props.rowData.b_modal.descr }}</span>
                                          <span class="badge badge-secondary" v-if="props.rowData.b_modal.descr=='Aquaviário'">{{ props.rowData.b_modal.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.b_modal.descr=='Dutoviário'">{{ props.rowData.b_modal.descr }}</span>
                                          <span class="badge badge-default" v-if="props.rowData.b_modal.descr=='Ferroviário'">{{ props.rowData.b_modal.descr }}</span>
                                        </template>
                                        <template slot="tomador_cnpj" slot-scope="props">
                                            <span>{{ props.rowData.doc_cte_partes_env.tom_cnpj }}</span>
                                          </template>
                                    </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal id="modal_sel_cte_form"
                 ref="modal_sel_cte_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 v-model="showModalSelect"
                 :ok-disabled=form.errors.any()
                 @ok="handleOk">
                 Selecione o Modal do MDFE
                 <div class="row bs-glyphicons">

                    <div class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerarCte($event, 3)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-3x fa-ship" aria-hidden="true"></i> <br/>Aquaviário
                            </div>
                        </a>
                    </div>

                    <div class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerarCte($event, 1)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-3x fa-truck" aria-hidden="true"></i> <br/>Rodoviário
                            </div>
                        </a>
                    </div>

                    <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                        <a  href='#' @click="onGerarCte($event, 2)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-3x fa-plane" aria-hidden="true"></i> <br/>Aéreo
                            </div>
                        </a>
                    </div>

                    <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerarCte($event, 4)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-3x fa-train" aria-hidden="true"></i> <br/>Ferroviário
                            </div>
                        </a>
                    </div>

                 </div>

             <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-btn @click="showModalSelect=false" variant="secondary">
                          Fechar
                        </b-btn>
                    </div>
             </div>
        </b-modal>

        <!-- Modal Component -->
        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 size="lg"
                 v-model="showModal"
                 :ok-disabled=form.errors.any()
                 @ok="handleOk">
            <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
              <b-container fluid class="p-a-0">
                  <b-row>
                      <b-col v-if="this.form.modal==1">
                          <label>RNTRC</label>
                          <b-form-input type="text"
                                      placeholder="RNTRC"
                                      v-model="form.rntrc"
                                      name="rntrc"
                                      >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('rntrc')" v-if="form.errors.has('rntrc')"></b-form-feedback>
                      </b-col>
                      <b-col>
                          <label>Total de documentos selecionados <br/><strong>{{ total_doc }} Documentos </strong></label>
                      </b-col>

                  </b-row>

                  <b-row>
                      <b-col>
                        <h4 class="panel-title">Observação Geral</h4>
                        <b-form-textarea id="textarea1"
                                         name="obs"
                                         v-model="form.obs"
                                         placeholder="Observação"
                                         :rows="4"
                                         :max-rows="4">
                        </b-form-textarea>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                    </b-col>
                    <b-col>

                        <h4 class="panel-title">Observação Fisco</h4>
                        <b-form-textarea id="textarea1"
                                         name="obs"
                                         v-model="form.obs_fisco"
                                         placeholder="Observação Fisco"
                                         :rows="4"
                                         :max-rows="4">
                        </b-form-textarea>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco')" v-if="form.errors.has('obs_fisco')"></b-form-feedback>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col>
                      <br/>
                      <h3 class="panel-title">Detalhes do MDFE </h3>
                      <b-tabs>
                        <b-col v-if="this.form.modal==3">
                        <b-tab title="Terminais">
                          <table class="table-striped">
                            <label>Terminal de Embarque</label>
                            <multiselect v-model="form.termembarque"
                            :options="optionsTerminal"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('termembarque')" v-if="form.errors.has('termembarque')"></b-form-feedback>

                            <label>Terminal de Desembarque</label>
                            <multiselect v-model="form.termdesembarque"
                            :options="optionsTerminal"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('termdesembarque')" v-if="form.errors.has('termdesembarque')"></b-form-feedback>
                          </table>
                        </b-tab>
                      </b-col>
                      <b-col  v-if="this.form.modal==1">
                      <b-tab title="Veículos">
                        <table class="table-striped">
                          <b-row>
                              <b-col>
                                <label>Veículo Tração</label>
                                <multiselect v-model="form.veiculo_tracao"
                                :options-limit="300"
                                :limit="3"
                                :limit-text="limitText"
                                :options="optionsVeiculo"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Veículo ( Digite ao menos 3 caracteres, Placa, Renavam, CUIT, Nome ou Razão Social )"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                :searchable="true"
                                :loading="isLoadingTracao"
                                @search-change="listaVeiculo"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_tracao')" v-if="form.errors.has('veiculo_tracao')"></b-form-feedback>
                              </b-col>
                              </b-row>
                              <b-row no-gutters>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>Placa</label>
                                  <b-form-input type="text"
                                              placeholder="Placa"
                                              v-model="form.veiculo_tracao.placa"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('placa')" v-if="form.errors.has('placa')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>Renavam</label>
                                  <b-form-input type="text"
                                              placeholder="Renavam"
                                              v-model="form.veiculo_tracao.renavam"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('placa')" v-if="form.errors.has('placa')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>UF</label>
                                  <b-form-input type="text"
                                              placeholder="UF"
                                              v-model="form.veiculo_tracao.uf"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('uf')" v-if="form.errors.has('uf')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label" >
                              <label>Cap. KG</label>
                              <b-form-input type="text"
                                          placeholder="Cap. KG"
                                          v-model="form.veiculo_tracao.capacidade_kg"
                                          name="Capacidade KG"
                                          disabled
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('capacidade_kg')" v-if="form.errors.has('capacidade_kg')"></b-form-feedback>

                              </b-col >
                              <b-col v-if="form.veiculo_tracao.label">
                                <label>Cap. M3</label>
                                <b-form-input type="text"
                                            placeholder="Cap. M3"
                                            v-model="form.veiculo_tracao.capacidade_m3"
                                            name="Capacida M3"
                                            disabled
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('capacidade_m3')" v-if="form.errors.has('capacidade_m3')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                <label>Tara</label>
                                <b-form-input type="text"
                                            placeholder="Tara"
                                            v-model="form.veiculo_tracao.tara"
                                            name="Tara"
                                            disabled
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('tara')" v-if="form.errors.has('tara')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>Carroceria</label>
                                  <b-form-input type="text"
                                              placeholder="Carroceria"
                                              v-model="form.veiculo_tracao.carroceria_descr"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('carroceria_descr')" v-if="form.errors.has('carroceria_descr')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>Tipo Rodado</label>
                                  <b-form-input type="text"
                                              placeholder="Tipo Rodado"
                                              v-model="form.veiculo_tracao.rodado_descr"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rodado_descr')" v-if="form.errors.has('rodado_descr')"></b-form-feedback>
                              </b-col>
                              <b-col v-if="form.veiculo_tracao.label">
                                  <label>Tipo Proprietário</label>
                                  <b-form-input type="text"
                                              placeholder="Tipo Proprietário"
                                              v-model="form.veiculo_tracao.proprietario_descr"
                                              name="placa"
                                              disabled
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('proprietario_descr')" v-if="form.errors.has('proprietario_descr')"></b-form-feedback>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col v-if="this.veiculo_reboque.length<=2">
                                <label>Veículo Reboque</label>
                                <multiselect @select="AddReboque"
                                :options-limit="300"
                                :limit="3"
                                :limit-text="limitText"
                                :options="optionsVeiculoReboque"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Reboque ( Digite ao menos 3 caracteres, Placa, Renavam, CUIT, Nome ou Razão Social )"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                :searchable="true"
                                :loading="isLoadingReboque"
                                @search-change="listaVeiculoReboque"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.value')" v-if="form.errors.has('veiculo_reboque.value')"></b-form-feedback>
                              </b-col>
                          </b-row>
                          <table class="table-striped">
                              <tbody v-for="(row, index) in veiculo_reboque">
                                  <b-row no-gutters>
                                      <b-col>
                                            <label>Placa</label>
                                            <b-form-input type="text"
                                                        placeholder="Placa"
                                                        v-model="row.placa"
                                                        name="placa"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.placa')" v-if="form.errors.has('veiculo_reboque.'+index+'.placa')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                            <label>Renavam</label>
                                            <b-form-input type="text"
                                                        placeholder="Renavam"
                                                        v-model="row.renavam"
                                                        name="renavam"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.renavam')" v-if="form.errors.has('veiculo_reboque.'+index+'.renavam')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>UF</label>
                                            <b-form-input type="text"
                                                        placeholder="UF"
                                                        v-model="row.uf"
                                                        name="placa"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.uf')" v-if="form.errors.has('veiculo_reboque.'+index+'.uf')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Cap. KG</label>
                                            <b-form-input type="text"
                                                        placeholder="Cap. KG"
                                                        v-model="row.capacidade_kg"
                                                        name="Capacidade KG"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.capacidade_kg')" v-if="form.errors.has('veiculo_reboque.'+index+'.capacidade_kg')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Cap. M3</label>
                                            <b-form-input type="text"
                                                        placeholder="Cap. M3"
                                                        v-model="row.capacidade_m3"
                                                        name="Capacida M3"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.capacidade_m3')" v-if="form.errors.has('veiculo_reboque.'+index+'.capacidade_m3')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Tara</label>
                                            <b-form-input type="text"
                                                        placeholder="Tara"
                                                        v-model="row.tara"
                                                        name="Tara"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.tara')" v-if="form.errors.has('veiculo_reboque.'+index+'.tara')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Carroceria</label>
                                            <b-form-input type="text"
                                                        placeholder="Carroceria"
                                                        v-model="row.carroceria_descr"
                                                        name="placa"
                                                        disabled
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('veiculo_reboque.'+index+'.carroceria_descr')" v-if="form.errors.has('veiculo_reboque.'+index+'.carroceria_descr')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Ação</label>
                                            <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Reboque'" v-on:click="removeRowReboque(index);"></i>
                                        </b-col>
                                </b-row>
                            </tbody>
                        </table>

                    </table>
                </b-tab>
            </b-col>

            <b-col v-if="this.form.modal==1">
                <b-tab title="Motorista">
                    <table class="table-striped">
                        <thead>
                            <tr>
                                <th style="width: 90%">Motorista</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr v-for="(row, index) in motorista">
                                <td>
                                    <multiselect v-model="row.dados"
                                    :options="optionsMotorista"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('motorista.'+index+'.dados')" v-if="form.errors.has('motorista.'+index+'.dados')"></b-form-feedback>
                                </td>
                                <td>
                                    <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Motorista'" v-on:click="removeRowMotorista(index);"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-striped" v-if="motorista.length<=9">
                        <tbody>
                            <tr class="table-info" style="display: table-row;">
                                <td colspan="11" style="width: 90%">
                                </td>
                                <td class='text-right' style="width: 90%; ">
                                    <i class="fa fa-plus-square" v-on:click="addRowMotorista($event);" v-b-tooltip.hover.right="'Adicionar Motorista'" style="cursor: pointer"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  </b-tab>
              </b-col>
                  <b-col  v-if="this.form.modal==1">
                    <b-tab title="Lacre" >
                      <table class="table-striped">
                          <thead>
                              <tr>
                                  <th colspan="11">Lacre</th>
                                  <th>Ações</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr v-for="(row, index) in lacre">
                                    <td colspan="11">
                                        <b-form-input type="text"
                                                    placeholder="Lacre"
                                                    v-model="row.num_lacre"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('lacre.'+index+'.num_lacre')" v-if="form.errors.has('lacre.'+index+'.num_lacre')"></b-form-feedback>
                                    </td>
                                    <td>
                                       <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Lacre'" v-on:click="removeRowLacre(index);"></i>
                                   </td>
                              </tr>
                          </tbody>
                      </table>
                      <table class="table-striped">
                          <tbody>
                              <tr class="table-info" style="display: table-row;">
                                  <td colspan="11" style="width: 90%">
                                  </td>
                                  <td class='text-right' style="width: 90%; ">
                                      <i class="fa fa-plus-square" v-on:click="addRowLacre($event);" v-b-tooltip.hover.right="'Adicionar Lacre'" style="cursor: pointer"></i>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                    </b-tab>
                </b-col>
                <b-col  v-if="this.form.modal==1">
                    <b-tab title="CIOT">
                        <table class="table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 30%">CIOT</th>
                                    <th style="width: 30%">CPF <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do CIOT" placement="top">[?]</span></th>
                                    <th style="width: 30%">CNPJ <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do CIOT" placement="top">[?]</span></th>
                                    <th style="width: 10%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr v-for="(row, index) in ciot">
                                     <td>
                                          <b-form-input type="text"
                                                      placeholder="CIOT"
                                                      v-model="row.ciot"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('ciot.'+index+'.ciot')" v-if="form.errors.has('ciot.'+index+'.ciot')"></b-form-feedback>
                                     </td>
                                     <td>
                                           <b-form-input type="text"
                                                       placeholder="CPF"
                                                       v-model="row.cpf"
                                                       >
                                           </b-form-input>
                                           <b-form-feedback class="text-danger" v-text="form.errors.get('ciot.'+index+'.cpf')" v-if="form.errors.has('ciot.'+index+'.cpf')"></b-form-feedback>
                                       </td>
                                       <td>
                                            <b-form-input type="text"
                                                        placeholder="CNPJ"
                                                        v-model="row.cnpj"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('ciot.'+index+'.cnpj')" v-if="form.errors.has('ciot.'+index+'.cnpj')"></b-form-feedback>
                                        </td>
                                        <td>
                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover CIOT'" v-on:click="removeRowCiot(index);"></i>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                        <table class="table-striped">
                            <tbody>
                                <tr class="table-info" style="display: table-row;">
                                    <td colspan="11" style="width: 90%">
                                    </td>
                                    <td class='text-right' style="width: 90%; ">
                                        <i class="fa fa-plus-square" v-on:click="addRowCiot($event);" v-b-tooltip.hover.right="'Adicionar CIOT'" style="cursor: pointer"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-tab>
                </b-col>
                <b-col  v-if="this.form.modal==1">
                    <b-tab title="Contratante" >
                      <table class="table-striped">
                          <thead>
                              <tr>
                                  <th style="width: 40%">CPF <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do contratante" placement="top">[?]</span></th>
                                  <th style="width: 50%">CNPJ <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do contratante" placement="top">[?]</span></th>
                                  <th style="width: 10%">Ações</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr v-for="(row, index) in contratante">
                                   <td>
                                     <b-form-input type="text"
                                                 placeholder="CPF"
                                                 v-model="row.cpf"
                                                 >
                                     </b-form-input>
                                     <b-form-feedback class="text-danger" v-text="form.errors.get('contratante.'+index+'.cpf')" v-if="form.errors.has('contratante.'+index+'.cpf')"></b-form-feedback>
                                    </td>
                                    <td>
                                      <b-form-input type="text"
                                                  placeholder="CNPJ"
                                                  v-model="row.cnpj"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('contratante.'+index+'.cnpj')" v-if="form.errors.has('contratante.'+index+'.cnpj')"></b-form-feedback>
                                     </td>
                                  <td>
                                    <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Contratante'" v-on:click="removeRowContratante(index);"></i>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table class="table-striped">
                          <tbody>
                              <tr class="table-info" style="display: table-row;">
                                  <td colspan="11" style="width: 90%">
                                  </td>
                                  <td class='text-right' style="width: 90%; ">
                                      <i class="fa fa-plus-square" v-on:click="addRowContratante($event);" v-b-tooltip.hover.right="'Adicionar Contratante'" style="cursor: pointer"></i>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                    </b-tab>
                </b-col>

              <b-col v-if="this.form.modal==1">
              <b-tab title="Seguro">
                <table class="table-striped">
                    <thead>
                        <tr>
                            <th style="width: 45%">Responsável pelo seguro *</th>
                            <th style="width: 45%">Seguradora * <span v-b-tooltip title="Você cadastra a apolice e seguradora em Cadastros -> Cliente -> Seguradora" placement="top">[?]</span></th>
                            <th style="width: 5%">Ações</th>
                        </tr>
                     </thead>
                     <tbody v-for="(row, index) in seguro">
                         <tr>
                            <td>
                                  <multiselect v-model="row.respseg"
                                  :options="optionsParamRespSeg"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Selecione"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                            </td>
                            <td>
                              <multiselect v-model="row.seguradora"
                              :options="optionsSeguradora"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                            </td>
                            <td>
                                <i class="fa fa-plus-square-square-o" v-on:click="addRowAverbacao($event,row);" v-b-tooltip.hover.right="'Adicionar Nº Averbação'" style="cursor: pointer"></i>
                                <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Seguro'" v-on:click="removeRowSeguro(index);"></i>
                            </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <table class="table-striped">
                                <tr>
                                    <th style="width: 30%">Nº Averbação</th>
                                    <th style="width: 10%">Ações</th>
                                </tr>
                                 <tbody>
                                    <tr v-for="(row2, index2) in row.averbacao" style="display: table-row;">
                                      <td>
                                            <b-form-input type="text"
                                                        placeholder="Descrição"
                                                        v-model="row2.num_averbacao"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.averbacao.'+index2+'.num_averbacao')" v-if="form.errors.has('seguro.'+index+'.averbacao.'+index2+'.num_averbacao')"></b-form-feedback>
                                      </td>
                                      <td>
                                        <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Averbação'" v-on:click="removeRowAverbacao(row,index2);"></i>
                                      </td>
                                   </tr>
                                </tbody>
                             </table>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table-striped">
                    <tbody>
                        <tr class="table-info" style="display: table-row;">
                            <td colspan="11" style="width: 90%">
                            </td>
                            <td class='text-right' style="width: 90%; ">
                                <i class="fa fa-plus-square" v-on:click="addRowSeguro($event);" v-b-tooltip.hover.right="'Adicionar Seguro'" style="cursor: pointer"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </b-tab>
            </b-col>
            <b-col  v-if="this.form.modal==1">
              <b-tab title="Vale pedágio" >
                <table class="table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%">CNPJ Fornecedor</th>
                            <th style="width: 20%">CNPJ Pagador <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do pagador" placement="top">[?]</span></th>
                            <th style="width: 20%">CPF Pagador <span v-b-tooltip title="Você deve informar ou o CPF ou o CNPJ do pagador" placement="top">[?]</span></th>
                            <th style="width: 15%">N° da compra</th>
                            <th style="width: 15%">Valor do vale</th>
                            <th style="width: 10%">Ações</th>
                        </tr>
                     </thead>
                     <tbody>
                         <tr v-for="(row, index) in vale_pedagio">
                           <td>
                                 <b-form-input type="text"
                                             placeholder="CNPJ Fornecedor"
                                             v-model="row.cnpj_fornecedor"
                                             >
                                 </b-form-input>
                                 <b-form-feedback class="text-danger" v-text="form.errors.get('vale_pedagio.'+index+'.cnpj_fornecedor')" v-if="form.errors.has('vale_pedagio.'+index+'.cnpj_fornecedor')"></b-form-feedback>
                            </td>
                            <td>
                                  <b-form-input type="text"
                                              placeholder="CNPJ Pagador"
                                              v-model="row.cnpj_pagador"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vale_pedagio.'+index+'.cnpj_pagador')" v-if="form.errors.has('vale_pedagio.'+index+'.cnpj_pagador')"></b-form-feedback>
                             </td>
                             <td>
                                   <b-form-input type="text"
                                               placeholder="CPF Pagador"
                                               v-model="row.cpf_pagador"
                                               >
                                   </b-form-input>
                                   <b-form-feedback class="text-danger" v-text="form.errors.get('vale_pedagio.'+index+'.cpf_pagador')" v-if="form.errors.has('vale_pedagio.'+index+'.cpf_pagador')"></b-form-feedback>
                              </td>
                              <td>
                                    <b-form-input type="text"
                                                placeholder="N° da compra"
                                                v-model="row.num_compra"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('vale_pedagio.'+index+'.num_compra')" v-if="form.errors.has('vale_pedagio.'+index+'.num_compra')"></b-form-feedback>
                               </td>
                               <td>
                                     <b-form-input type="text"
                                                 placeholder="Valor do vale"
                                                 v-model="row.vlr_vale"
                                                 >
                                     </b-form-input>
                                     <b-form-feedback class="text-danger" v-text="form.errors.get('vale_pedagio.'+index+'.vlr_vale')" v-if="form.errors.has('vale_pedagio.'+index+'.vlr_vale')"></b-form-feedback>
                                </td>
                            <td>
                                  <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Vale Pedágio'" v-on:click="removeRowValePedagio(index);"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table-striped">
                    <tbody>
                        <tr class="table-info" style="display: table-row;">
                            <td colspan="11" style="width: 90%">
                            </td>
                            <td class='text-right' style="width: 90%; ">
                                <i class="fa fa-plus-square" v-on:click="addRowValePedagio($event);" v-b-tooltip.hover.right="'Adicionar Vale Pedágio'" style="cursor: pointer"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </b-tab>
          </b-col>
      </b-tabs>
  </b-col>
</b-row>
</b-container fluid class="p-a-0">
</form>

            <div slot="modal-footer" class="w-100">
                   <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                   <div class="float-right">
                       <div class="float-left" v-if="this.errors_array.length>0">
                           <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                             <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                               <table class="table-striped" id="mais">
                                    <tbody>
                                        <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                           <td>
                                             {{ item.erro }}
                                           </td>
                                       </tr>
                                   </tbody>
                               </table>
                             </b-popover>
                         </div>
                       &nbsp;

                       <b-btn @click="showModal=false" variant="secondary">
                         Cancelar
                       </b-btn>
                       <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                         Gerar MDFE
                       </b-btn>
                   </div>
               </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GerarMdfeFilterBar from "./GerarMdfeFilterBar";
import accounting from "accounting";
import moment from "moment";
import GerarMdfeDetalhes from "./GerarMdfeDetalhes";

Vue.component("gerar-mdfe-detalhes", GerarMdfeDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": GerarMdfeFilterBar
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalSelect: false,
      isLoadingTracao: false,
      isLoadingReboque: false,
      isFullscreen: false,
      showModalErp: false,
      showPopover: false,
      helpForm: new Form({
        statusRecord: [],
        params: [],
        search: "",
        bcliente_id_active: ""
      }),
      optionsTerminal: [],
      optionsTerminal: [],
      optionsMotorista: [],
      optionsLacre: [],
      optionsParamRespSeg: [],
      optionsSeguradora: [],
      total_doc: 0,
      doc: [],
      errors_array: [],
      optionsVeiculo: [
        {
          placa: "",
          label: "",
          value: "",
          renavam: "",
          municipio: "",
          carroceria: "",
          carroceria_id: "",
          rodado: "",
          rodado_id: "",
          propriedade: "",
          propriedade_id: "",
          proprietario: "",
          proprietario_id: "",
          uf: "",
          capacidade_kg: "",
          capacidade_m3: ""
        }
      ],

      optionsVeiculoReboque: [
        {
          placa: "",
          label: "",
          value: "",
          renavam: "",
          municipio: "",
          carroceria: "",
          carroceria_id: "",
          rodado: "",
          propriedade: "",
          proprietario: "",
          uf: "",
          capacidade_kg: "",
          capacidade_m3: ""
        }
      ],
      veiculo_reboque: [],
      motorista: [{ dados: [] }],
      lacre: [{ num_lacre: "" }],
      ciot: [{ ciot: "", cpf: "", cnpj: "" }],

      contratante: [{ cpf: "", cnpj: "" }],

      vale_pedagio: [
        {
          cnpj_fornecedor: "",
          cnpj_pagador: "",
          cpf_pagador: "",
          num_compra: "",
          vlr_vale: ""
        }
      ],

      seguro: [
        { respseg: [], seguradora: [], averbacao: [{ num_averbacao: "" }] }
      ],

      form: new Form({
        termembarque: "",
        termdesembarque: "",
        obs: "",
        obs_fisco: "",
        rntrc: "",
        doc: [],
        veiculo_tracao: [],
        veiculo_reboque: [],
        motorista: [],
        lacre: [],
        ciot: [],
        contratante: [],
        seguro: [],
        vale_pedagio: [],
        modal: ""
      }),
      formerp: new Form({
        doctpaen_id: "",
        tipo_erp: "",
        cd: ""
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "num_controle",
          title: "Nº Controle"
        },
        {
          name: "num_fiscal",
          title: "N° Fiscal"
        },
        {
          name: "serie",
          title: "Série"
        },
        {
          name: "dt_emi",
          title: "Data Emissão",
          callback: "formatDate|DD/MM/YYYY h:mm:ss"
        },
        {
          name: "status.descr",
          title: "Status Documento"
        },
        {
          name: "__slot:status_sefaz",
          title: "Status Sefaz"
        },
        {
          name: "__slot:b_modal",
          title: "Modal"
        },
        {
          name: "municipio_inicio.nome",
          title: "Município de início"
        },
        {
          name: "municipio_fim.nome",
          title: "Município de fim"
        },
        {
          name: "__slot:tomador_cnpj",
          title: "Tomador"
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
    this.getListItemGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        navio_viagem: data_filter.filterTextNavioViagem,
        num_fiscal: data_filter.num_fiscal,
        dt_inicio: data_filter.dt_inicio,
        dt_fim: data_filter.dt_fim,
        embarcacao_id: data_filter.embarcacao_id,
        num_viagem: data_filter.num_viagem,
        status_sefaz: data_filter.status_sefaz.value,
        porto_embarque: data_filter.porto_embarque.value,
        porto_destino: data_filter.porto_destino.value,
        municipio_inicio: data_filter.municipio_inicio.value,
        municipio_fim: data_filter.municipio_fim.value,
        des_cnpj: data_filter.des_cnpj,
        tom_cnpj: data_filter.tom_cnpj,
        modal: data_filter.modal.value
      };
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.doc_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.parareemp_id);
      }
    },
    onCreate(data) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.bcliente_id_active = this.user.bcliente_id_active;
      this.helpForm
        .post("/api/mdfe/getmdfe")
        .then(response => {
          if (response.periodo) {
            var obj = {
              isShown: true,
              title: "Erro",
              message:
                "Seu periodo expirou. Caso queria fazer um upgrade de versão" +
                "<a target='_blank' href='/dashboard#/conta'> clique aqui</a>",
              type: "error",
              customCloseBtnText: "Fechar",
              useConfirmBtn: false
            };
            this.$Simplert.open(obj);
          } else {
            if (response.mdfe <= this.b_plano.qtde_mdfe) {
              this.modal_titulo = "Gerar MDFE";
              this.modal_botao = "Gerar MDFE"; // OK
              this.modal_acao = "i";
              this.termembarque = null;
              this.termembarque = [];
              this.termdesembarque = null;
              this.termdesembarque = [];
              this.veiculo_reboque = null;
              this.veiculo_reboque = [];
              this.seguro = null;
              this.seguro = [];
              this.lacre = null;
              this.lacre = [];
              this.ciot = null;
              this.ciot = [];
              this.contratante = null;
              this.contratante = [];
              this.vale_pedagio = null;
              this.vale_pedagio = [];
              this.motorista = null;
              this.motorista = [];
              this.form.doc = [];
              this.total_doc = 0;
              this.$refs.vuetable.selectedTo.forEach(obj => {
                this.form.doc.push({ id: obj });
                this.total_doc = this.total_doc + 1;
              });
              this.$refs.modal_sel_cte_form.show();
            } else {
              var obj = {
                isShown: true,
                title: "Erro",
                message:
                  "Você atingiu o limite de MDFes ativas cadastradas para o seu plano " +
                  response.mdfe +
                  "/" +
                  this.b_plano.qtde_mdfe +
                  ". Caso queria fazer um upgrade de versão" +
                  "<a target='_blank' href='/dashboard#/conta'> clique aqui</a>",
                type: "error",
                customCloseBtnText: "Fechar",
                useConfirmBtn: false
              };
              this.$Simplert.open(obj);
            }
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onGerarCte(e, modal) {
      e.preventDefault();
      this.doc = null;
      this.doc = [];
      this.form.doc.forEach(doc_id => {
        this.$refs.vuetable.tableData.forEach(obj => {
          if (obj.doc_id == doc_id.id) {
            this.doc.push({
              id: obj.doc_id,
              chave: obj.chave,
              num_fiscal: obj.num_fiscal,
              serie: obj.serie,
              dt_emissao: obj.dt_emissao
            });
          }
        });
      });
      this.modal_titulo = "Gerar MDFE";
      this.modal_botao = "Gerar MDFE";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.form.modal = modal;
      this.$refs.modal_sel_cte_form.hide();
      this.$refs.modal_form.show();
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.motorista = this.motorista;
      this.form.lacre = this.lacre;
      this.form.ciot = this.ciot;
      this.form.contratante = this.contratante;
      this.form.seguro = this.seguro;
      this.form.vale_pedagio = this.vale_pedagio;
      this.form.veiculo_reboque = this.veiculo_reboque;
      this.form.doc = this.doc;
      this.form
        .post("/api/gerarmdfe/gerar")
        .then(response => {
          new ReturnApi(response, this);
        })
        .catch(errors => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    listaVeiculo(search) {
      if (search.length >= 3) {
        this.isLoadingTracao = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/veiculo/jsonlist")
          .then(response => {
            this.optionsVeiculo = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach(obj => {
              this.optionsVeiculo.push({
                label: obj.placa + " - " + obj.renavam,
                value: obj.veiculo_id,
                placa: obj.placa,
                renavam: obj.renavam,
                capacidade_m3: obj.capacidade_m3,
                capacidade_kg: obj.capacidade_kg,
                tara: obj.tara,
                uf: obj.municipio.uf.cd,
                tp_carroceria: obj.param_tipo_carroceria.cd,
                carroceria_descr: obj.param_tipo_carroceria.descr,
                tp_proprietario: obj.param_tipo_proprietario.cd,
                partiprod_id: obj.param_tipo_rodado.partiprod_id,
                tp_rodado: obj.param_tipo_rodado.cd,
                rodado_descr: obj.param_tipo_rodado.descr,
                partipvei_id: obj.param_tipo_veiculo.partipvei_id,
                tp_veiculo_descr: obj.param_tipo_veiculo.descr
              });
            });
            this.isLoadingTracao = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaVeiculoReboque(search) {
      if (search.length >= 3) {
        this.isLoadingReboque = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/veiculo/jsonlistReboque")
          .then(response => {
            this.optionsVeiculoReboque = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach(obj => {
              this.optionsVeiculoReboque.push({
                label: obj.placa + " - " + obj.renavam,
                value: obj.veiculo_id,
                placa: obj.placa,
                renavam: obj.renavam,
                capacidade_m3: obj.capacidade_m3,
                capacidade_kg: obj.capacidade_kg,
                tara: obj.tara,
                uf: obj.municipio.uf.cd,
                partipcro_id: obj.param_tipo_carroceria.partipcro_id,
                carroceria_descr: obj.param_tipo_carroceria.descr,
                param_tipo_carroceria: obj.param_tipo_carroceria,
                param_tipo_proprietario: obj.param_tipo_proprietario,
                param_tipo_rodado: obj.param_tipo_rodado,
                tp_carroceria: obj.param_tipo_carroceria.cd,
                proprietario_descr: obj.param_tipo_proprietario.descr,
                rodado_descr: obj.param_tipo_rodado.descr,
                tp_veiculo_descr: obj.param_tipo_veiculo.descr
              });
            });
            this.isLoadingReboque = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    getListItemGeral() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .get("/api/gerarmdfe/jsonlistgeral")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.motoristas.forEach(obj => {
            this.optionsMotorista.push({
              label:
                obj.pessoa.pessoa_fisica.nome +
                " - " +
                obj.pessoa.pessoa_fisica.cpf,
              cpf: obj.pessoa.pessoa_fisica.cpf,
              nome: obj.pessoa.pessoa_fisica.nome,
              pesmot_id: obj.pesmot_id,
              value: obj.pesmot_id
            });
          });

          response.resp_seg.forEach(obj => {
            this.optionsParamRespSeg.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.partprese_id
            });
          });

          response.seguradora.forEach(obj => {
            this.optionsSeguradora.push({
              label: obj.nome + " - " + obj.apolice,
              value: obj.segurado_id
            });
          });

          response.terminais.forEach(obj => {
            this.optionsTerminal.push({
              label: obj.descr,
              value: obj.terminal_id
            });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    AddReboque: function(selectedOption, id) {
      this.veiculo_reboque.push({
        placa: selectedOption.placa,
        renavam: selectedOption.renavam,
        tara: selectedOption.tara,
        capacidade_kg: selectedOption.capacidade_kg,
        capacidade_m3: selectedOption.capacidade_m3,
        tp_carroceria: selectedOption.param_tipo_carroceria,
        tp_proprietario: selectedOption.param_tipo_proprietario,
        tp_rodado: selectedOption.param_tipo_rodado,
        carroceria_descr: selectedOption.param_tipo_carroceria.descr,
        uf: selectedOption.uf,
        label: selectedOption.label,
        value: selectedOption.value
      });
    },
    removeRowReboque: function(index) {
      this.veiculo_reboque.splice(index, 1);
    },
    addRowMotorista: function(e) {
      e.preventDefault();
      this.motorista.push({ dados: [] });
    },
    removeRowMotorista: function(index) {
      this.motorista.splice(index, 1);
    },
    addRowLacre: function(e) {
      e.preventDefault();
      this.lacre.push({
        num_lacre: ""
      });
    },
    removeRowLacre: function(index) {
      this.lacre.splice(index, 1);
    },
    addRowCiot: function(e) {
      e.preventDefault();
      this.ciot.push({
        ciot: "",
        cpf: "",
        cnpj: ""
      });
    },
    removeRowCiot: function(index) {
      this.ciot.splice(index, 1);
    },
    addRowContratante: function(e) {
      e.preventDefault();
      this.contratante.push({
        cpf: "",
        cnpj: ""
      });
    },
    removeRowContratante: function(index) {
      this.contratante.splice(index, 1);
    },
    addRowSeguro: function(e) {
      e.preventDefault();
      this.seguro.push({
        seguradora: [],
        respseg: [],
        averbacao: []
      });
    },
    removeRowSeguro: function(index) {
      this.seguro.splice(index, 1);
    },
    addRowAverbacao: function(e, row) {
      e.preventDefault();
      row.averbacao.push({
        num_averbacao: ""
      });
    },
    removeRowAverbacao: function(row, index) {
      row.averbacao.splice(index, 1);
    },
    addRowValePedagio: function(e) {
      e.preventDefault();
      this.vale_pedagio.push({
        cnpj_pagador: "",
        cnpj_fornecedor: "",
        cpf_pagador: "",
        num_compra: "",
        vlr_vale: ""
      });
    },
    removeRowValePedagio: function(index) {
      this.vale_pedagio.splice(index, 1);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      }
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      }
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
